module.exports = __webpack_public_path__ + "img/1280AD.1465a364.png";